import React from 'react';
import PropTypes from 'prop-types';
import { Form, Radio, Popconfirm, notification } from 'antd';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { get } from 'lodash';
import { Collapse } from 'react-collapse';
// import moment from 'moment';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SelectField from '../../../../../parts/ui/components/fields/SelectField';
import CheckboxField from '../../../../../parts/ui/components/fields/CheckboxField';
import TextField from '../../../../../parts/ui/components/fields/TextField';
import EmailField from '../../../../../parts/ui/components/fields/EmailField';
import FundkyButton from '../../../../../parts/ui/components/FundkyButton';
import Countdown from '../../../../../common/Countdown';
import BuyerTypeField from './fields/BuyerTypeField';
import UserInformationCards from './UserInformationCardsContainer';
import { TICKETS_SALE_WIZARD_CONFIRMATION } from '../../eventUtils';
import { CAMPAIGN_TEMPLATE_SOLO, CAMPAIGN_TEMPLATE_PARTICIPANTS } from '../../../../../campaign/campaignUtils'
import { usernameFieldValidator, nameFieldValidator } from '../../../../../parts/ui/validations/fieldValidations';
import { setTicketSelectionAmount } from './../../../../../donation/components/ticketAmount';

import TicketsDetailsForm_en from './locales/TicketsDetailsForm_en.json';
import TicketsDetailsForm_fr from './locales/TicketsDetailsForm_fr.json';

import './TicketsDetailsForm.less';

class TicketsDetailsForm extends React.Component {
  constructor(props) {
    super(props);

    this.campaignId = get(props, 'ticketSelection.campaign.id');
    this.campaignTypeId = get(props, 'ticketSelection.campaign.typeId');
    
    if (this.campaignId && (this.campaignTypeId === 2 || this.campaignTypeId === 3)) {
      props.fetchCampaign(this.campaignId, false, null, { showSettings: true, showChildrenCount: true });
      props.searchTeamsInCampaign(this.campaignId, null, {}, {pageSize: 1000000}, null, false, true);
      let object = this;
      props.fetchParticipantByMemberId(false, this.campaignId).then(function(participant) {
        if(participant.payload && participant.payload['0'])
          participant = participant.payload['0'];
        else
          participant = null;

        // This line of code is only temporary. The system should allow users to switch teams if they're not leader of a team,
        // but for now, it's not possible due to foreign key constraints in the database.
        object.isLeader = false;
      })
    }

    const connected = props.userTypeId === 2;
    
    const displayTicketSection = connected && props.ticketSelection.tickets
      .filter(ticket => ticket.ticket.typeId === 1).length
        ? true
        : false;

    this.hasTeamRelatedFields = props.ticketSelection.tickets
      .filter(ticket => ticket.ticket.allowJoiningTeams === 1 || ticket.ticket.allowCreatingTeams === 1).length
      ? true : false;

    this.state = {
      openInfoCard: get(props, 'purchaseInformation.type', 0) > 0,
      isCorporate: get(props, 'purchaseInformation.type', 0) === 2,
      openSectionInformation: true,
      openSectionQuestion: connected && (this.campaignTypeId === 2 || this.campaignTypeId === 3),
      // openSectionQuestion: connected,
      openSectionTicket: displayTicketSection,
      openQuestionPage: props.purchaseInformation &&
        get(props.purchaseInformation, 'selectedPackage')
          ? true
          : false,
      openQuestionTeam: connected && this.campaignTypeId === 3,
      // openQuestionTeam: props.purchaseInformation && (
      //   get(props.purchaseInformation, 'participation.team.teamId', undefined) ||
      //   get(props.purchaseInformation, 'participation.team.name', undefined) ||
      //   get(props.purchaseInformation, 'participation.self', undefined))
      //     ? true
      //     : false,
      openBubbleTeam: connected && this.campaignTypeId === 2 ||
        props.purchaseInformation && (
          get(props.purchaseInformation, 'participation.team.teamId', undefined) ||
          get(props.purchaseInformation, 'participation.team.name', undefined)
        )
            ? true
            : false,
      // openBubbleTeam: props.purchaseInformation && (
      //   get(props.purchaseInformation, 'participation.team.teamId', undefined) ||
      //   get(props.purchaseInformation, 'participation.team.name', undefined))
      //     ? true
      //     : false,
      disableSelectPackage: props.purchaseInformation &&
        !get(props.purchaseInformation, 'selectedPackage')
          ? true
          : false,
      packageSelectRequired: props.purchaseInformation
        ? false
        : true,
      teamRequired: props.purchaseInformation && (
        get(props.purchaseInformation, 'participation.team.teamId', undefined) ||
        get(props.purchaseInformation, 'participation.team.name', undefined))
          ? false
          : true,
    };

    i18next.addResourceBundle('en', 'TicketsDetailsForm', TicketsDetailsForm_en);
    i18next.addResourceBundle('fr', 'TicketsDetailsForm', TicketsDetailsForm_fr);
  }

  componentDidMount() {
    this.total = 0;
    this.tickets = this.props.ticketSelection.tickets
      .map(row => {
        this.total += (parseFloat(row.ticket.totalPrice) * row.quantity);
        return row;
      });
    if(!this.total && this.props.userTypeId === 2) {
      const badge = document.getElementsByClassName("grecaptcha-badge")[0];
      if (badge && badge.classList && !badge.classList.contains("show")) {
        badge.classList.add("show");
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userTypeId !== this.props.userTypeId) {
      const connected = this.props.userTypeId === 2;

      // Redirect on disconnection
      if (!connected) {
        this.props.history.push(this.props.baseUrl);
      }

      const displayTicketSection = connected && this.props.ticketSelection.tickets
        .filter(ticket => ticket.ticket.typeId === 1).length
          ? true
          : false;

      this.setState({
        openSectionQuestion: connected && (this.campaignTypeId === 2 || this.campaignTypeId === 3),
        //openSectionQuestion: connected,
        openSectionTicket: displayTicketSection,
      });

      if (connected) {
        this.props.fetchCampaign(this.campaignId, false, null, { showSettings: true, showChildrenCount: true })
          .then(response => {
            const badge = document.getElementsByClassName("grecaptcha-badge")[0];
            if (badge && badge.classList && badge.classList.contains("show")) {
              badge.classList.remove("show");
            }
            if(get(response, 'payload.participating')) {
              this.props.history.push(`${this.props.baseUrl}`);
            }
          });
        const badge = document.getElementsByClassName("grecaptcha-badge")[0];
        if (badge && badge.classList && !badge.classList.contains("show")) {
          badge.classList.add("show");
        }

        this.setState({
          openQuestionTeam: this.campaignTypeId === 3,
          openBubbleTeam: this.campaignTypeId === 2 ||
            this.props.purchaseInformation && (
              get(this.props.purchaseInformation, 'participation.team.teamId', undefined) ||
              get(this.props.purchaseInformation, 'participation.team.name', undefined)
            )
                ? true
                : false,
        });
      } else {
        const badge = document.getElementsByClassName("grecaptcha-badge")[0];
        if (badge && badge.classList && badge.classList.contains("show")) {
          badge.classList.remove("show");
        }
      }

    }
  }

  getReCaptchaToken = async action => {
    return this.token = await this.props.googleReCaptchaProps.executeRecaptcha(action);
  };

  handleSubmit = e => {
    var _self = this;
    e.preventDefault();
    const
      { props, state, isProfileCompleted, getReCaptchaToken } = _self,
      { t, form, campaign, ticketSelection, user, savePurchaseInformation, purchaseTickets, history, baseUrl } = props,
      { isCorporate } = state,
      { validateFields, setFields } = form;

    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    validateFields({ force: true }, async (err, values) => {
      if (!err && isProfileCompleted()) {
        try {
          let newTeamNames = Object.keys(values).filter(k => k.startsWith("teamName")).map(k => values[k]).filter(v => v != null);
          let alreadyExistingNames = undefined;
          if(newTeamNames.length > 0) {
            alreadyExistingNames = await props.verifyTeamNames(newTeamNames, campaign.id)

            if(alreadyExistingNames !== undefined && Array.isArray(alreadyExistingNames.payload) && alreadyExistingNames.payload.length > 0) {
              let query = document.getElementsByTagName('input')
              for (let i of query) {
                if(!alreadyExistingNames.payload.includes(i.value) || !i.id.startsWith("teamName"))
                  continue;
                try {
                  setFields({
                    [i.id]: { 
                      value: [i.value],
                      errors: [new Error(t('name-already-taken'))]
                    }
                  })
                } catch (err) { console.error(err) }
              }
              return;
            }
            } 
          } catch { } // Fail silently if there are no teamName fields.
        _self.tickets = ticketSelection.tickets
        .map(row => ({
          ticketId: row.ticket.id,
          quantity: row.quantity,
          // attendees: get(campaign, 'typeId') !== CAMPAIGN_TEMPLATE_SOLO
          //   ? [{
            //       firstName: user.firstName,
            //       lastName: user.lastName,
            //       email: user.email
            //     }]
            //   : this.getAttendees(row.ticket.id, row.quantity, row.ticket.typeId)
            attendees: _self.getAttendees(row.ticket.id, row.quantity, row.ticket.typeId)
          }));

        const formValues = {
          tickets: this.tickets,
          // ...(values.radioQuestionPage
          //   ? {
          //       participation: {
          //         ...(values.teamSelect || values.teamName
          //           ? {
          //               team: {
          //                 ...(values.teamSelect
          //                   ? { teamId: values.teamSelect }
          //                   : {}
          //                 ),
          //                 ...(values.teamName
          //                   ? { name: values.teamName }
          //                   : {}
          //                 )
          //               }
          //             }
          //           : {
          //             self: true
          //           }
          //         )
          //       }
          //     }
          //   : {}
          // ),
          creditCardId: undefined,
          ...(values.packageSelect
            ? { selectedPackage: values.packageSelect }
            : {}
          ),

          ...(get(values, 'type')
            ? { donationTypeId: values.type }
            : {}
          ),
          transaction: {
            information: {
              ...(isCorporate && get(user, 'profiles.work.organization.title')
                ? { organizationTitle: user.profiles.work.organization.title }
                : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.organization.name')
                ? { organizationName: user.profiles.work.organization.name }
                : {}
              ),
              ...(get(user, 'firstName')
                ? { firstName: user.firstName }
                : {}
              ),
              ...(get(user, 'lastName')
                ? { lastName: user.lastName }
                : {}
              ),
              ...(get(user, 'honorificId')
                ? { honorificId: user.honorificId }
                : {}
              ),
              ...(get(user, 'email')
                ? { email: user.email }
                : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.country')
                ? { country: user.profiles.work.country }
                : get(user, 'profiles.general.country')
                  ? { country: user.profiles.general.country }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.province')
                ? { province: user.profiles.work.province }
                : get(user, 'profiles.general.province')
                  ? { province: user.profiles.general.province }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.city')
                ? { city: user.profiles.work.city }
                : get(user, 'profiles.general.city')
                  ? { city: user.profiles.general.city }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.address')
                ? { address: user.profiles.work.address }
                : get(user, 'profiles.general.address')
                  ? { address: user.profiles.general.address }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.unit')
                ? { unit: user.profiles.work.unit }
                : get(user, 'profiles.general.unit')
                  ? { unit: user.profiles.general.unit }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.postalCode')
                ? { postalCode: user.profiles.work.postalCode }
                : get(user, 'profiles.general.postalCode')
                  ? { postalCode: user.profiles.general.postalCode }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.phone.number')
                ? { phone: {
                      number: user.profiles.work.phone.number,
                      ...(get(user, 'profiles.work.phone.ext')
                        ? { ext: get(user, 'profiles.work.phone.ext') }
                        : {}
                      )
                    },
                  }
                : get(user, 'profiles.general.phone.number')
                  ? { phone: {
                        number: user.profiles.general.phone.number,
                        ...(get(user, 'profiles.general.phone.ext')
                          ? { ext: get(user, 'profiles.general.phone.ext') }
                          : {}
                        )
                      },
                    }
                  : {}
              ),
              ...(isCorporate && get(user, 'profiles.work.postalCode')
                ? { postalCode: user.profiles.work.postalCode }
                : get(user, 'profiles.general.postalCode')
                  ? { postalCode: user.profiles.general.postalCode }
                  : {}
              ),

            }
          }
        };

        savePurchaseInformation(formValues);
        if (_self.total > 0) {
          if (this.props.surveyId) {
            history.push(`${baseUrl}/${t('URL:ticket-purchase/survey')}`);
          } else {
            history.push(`${baseUrl}/${this.props.t('URL:ticket-purchase/payment')}`);
          }
        } else {
          if (this.props.surveyId) {
            getReCaptchaToken('donation').then(() => {
              const information = {
                //...formValues,
                tickets: formValues.tickets,
                participation: formValues.participation || undefined,
                reCAPTCHA: this.token,
                donationTypeId: formValues.donationTypeId || undifined,
                transaction: formValues.transaction || undefined
              };
              history.push({
                pathname: `${baseUrl}/${t('URL:ticket-purchase/survey')}`,
                state: { total: _self.total, information: information }
              });
            });
          } else {
            // Set reCAPTCHA token
            getReCaptchaToken('donation').then(() => {
              const information = {
                //...formValues,
                tickets: formValues.tickets,
                participation: formValues.participation || undefined,
                reCAPTCHA: this.token,
                donationTypeId: formValues.donationTypeId || undifined,
                transaction: formValues.transaction || undefined
              };
              purchaseTickets(campaign.id, information)
                .then(response => {
                  if (get(response, 'error.code', null)) {
                    notification.error({ message: t(`ERROR:${get(response, 'error.code')}`) });
                  }
                });
            });
          }
        }
      }
    });
  };

  handleSelectPackage = value => {
    // Clear everything
    this.setState({
      openQuestionTeam: false,
      openBubbleTeam: false,
      packageSelectRequired: false
    }, () => this.props.form.validateFields(['packageSelect', 'for_others'], { force: true }));

    this.props.form.setFieldsValue({
      radioQuestionPage: undefined,
      radioQuestionTeam: undefined,
      teamSelect: undefined,
      teamName: undefined
    });

    // Check if it's possible to participate
    if (
      value && (
        (this.campaignTypeId === 1 && this.display('questions')) ||
        ((this.campaignTypeId === 2 || this.campaignTypeId === 3)  && this.display('bubble'))
      )
    )
      this.setState({ openQuestionPage: true });

    // Assign User info to 1st ticket seleted
    if (value) {
      const formValues = this.props.form.getFieldsValue();

      for (let field in formValues) {
        if (
          field.indexOf('firstName_%1%#') > -1 &&
          formValues[field] === this.props.user.firstName ||
          field.indexOf('lastName_%1%#') > -1 &&
          formValues[field] === this.props.user.lastName ||
          field.indexOf('email_%1%#') > -1 &&
          formValues[field] === this.props.user.email
        )
          this.props.form.setFieldsValue({
            [field]: undefined
          });
      }

      if (
        formValues.hasOwnProperty('firstName_%1%#' + value) &&
        formValues.hasOwnProperty('lastName_%1%#' + value) &&
        formValues.hasOwnProperty('email_%1%#' + value)
      )
        this.props.form.setFieldsValue({
          ['firstName_%1%#' + value]: this.props.user.firstName,
          ['lastName_%1%#' + value]: this.props.user.lastName,
          ['email_%1%#' + value]: this.props.user.email
        });
    }
  };

  handleCheckForOtherPeople = event => {
    const value = get(event, 'target.checked', false) ? true : false;

    // Hide everthing and disable select or activate select
    this.setState({
      disableSelectPackage: value,
      ...(value
        ? {
          openQuestionPage: false,
          openQuestionTeam: false,
          openBubbleTeam: false,
          packageSelectRequired: false
        }
        : {
          packageSelectRequired: true
        })
    }, () => this.props.form.validateFields(['packageSelect', 'for_others'], { force: true }));

    // Clear form data if true
    if (value)
      this.props.form.setFieldsValue({
        packageSelect: undefined,
        radioQuestionPage: undefined,
        radioQuestionTeam: undefined,
        teamSelect: undefined,
        teamName: undefined
      });
  };

  handleRadioQuestionPage = event => {
    const value = get(event, 'target.value', false) ? true : false;
    const selectedTicketId = this.props.form.getFieldValue('packageSelect');
    const selectedTicketTypeId = this.props.ticketSelection.tickets
      .filter(ticket => ticket.ticket.id === selectedTicketId)
      .map(ticket => ticket.ticket.typeId)[0];

    // Display next fields step if it's possible
    if (
      this.campaignTypeId === 3 &&
      this.state.openQuestionTeam !== value &&
      selectedTicketTypeId === 1
    ) {
      this.setState({
        openQuestionTeam: value,
        ...(!value
          ? { openBubbleTeam : value }
          : {}
        )
      });
      if (!value) {
        this.props.form.setFieldsValue({
          radioQuestionTeam: undefined,
          teamSelect: undefined,
          teamName: undefined
        });
      }
    } else
    if (
      (
        this.campaignTypeId === 2 ||
        selectedTicketTypeId === 2 &&
        (
          this.campaignTypeId === 2 ||
          this.campaignTypeId === 3
        )
      ) &&
      this.state.openBubbleTeam !== value &&
      this.display('bubble')
    ) {
      this.setState({
        openBubbleTeam: value
      });

      if (!value) {
        this.props.form.setFieldsValue({
          teamSelect: undefined,
          teamName: undefined
        });
      }
    }
  };

  handleRadioQuestionTeam = event => {
    const value = get(event, 'target.value', false) ? true : false;

    if (this.state.openBubbleTeam !== value && this.display('bubble')) {
      this.setState({
        openBubbleTeam: value
      });

      if (!value) {
        this.props.form.setFieldsValue({
          teamSelect: undefined,
          teamName: undefined
        });
      }
    }
  };

  handleBubbleFields = (field, value, _count, id, associatedId) => {
    const { setFieldsValue, validateFields } = this.props.form;

    let name, select;

    switch (field) {
      case 'select':
        setFieldsValue({[`teamName_%${_count}%#${id}`]: undefined });
        name = undefined;
        select = value;
        break;
      case 'text':
        setFieldsValue({ [`teamSelect_%${_count}%#${id}`]: undefined });
        name = value.target.value === ''
          ? undefined
          : value.target.value;
        select = undefined;
        break;
    }

    if(value !== '' && associatedId) {
      let associatedField = document.getElementById(associatedId);
      if(associatedField)
        associatedField.required = false;
    }
  };

  handleCancelClick = e => {
    e.preventDefault();
    this.props.cancelTransaction();
    this.props.handleTabChange(TICKETS_SALE_WIZARD_CONFIRMATION, true);
  };

  getTicketsInfoFields = () => {
    const { t, form, ticketSelection, purchaseInformation, event } = this.props;

    const selection = get(ticketSelection, 'tickets', null);
    const fields = [];

    const required = true; // Get the option from API

    let selected, id, type, quantity, name, i, count = 1, _count = 1, _id, canJoinTeam, canCreateTeam;

    if (selection) {
      for (selected in selection) {
        type = get(selection, `[${selected}]ticket.typeId`, null);
        quantity = get(selection, `[${selected}]quantity`, null);
        id = get(selection, `[${selected}]ticket.id`, null);
        name = get(selection, `[${selected}]ticket.description.name`, null);
        canJoinTeam = get(selection, `[${selected}]ticket.allowJoiningTeams`, null);
        canCreateTeam = get(selection, `[${selected}]ticket.allowCreatingTeams`, null);

        if (id !== _id) {
          _id = id;
          _count = 1;
        }

        if (quantity > 0 && (name || id)) {
          for (i = 0; i < quantity; i++) {
            let currentId = id;
            let currentCount = _count;
            fields.push(
              <div key={count} className="TicketsDetailsForm__Ticket">
                <h3>{t('ticket', { count: count, name: name || `#${id}`})}</h3>
                <div className="TicketsDetailsForm__Ticket--row">
                  {canCreateTeam &&       
                    <TextField
                      form={form}
                      fieldId={`teamName_%${_count}%#${id}`}
                      placeholder={t('team-name-placeholder')}
                      required={(required && this.otherFieldEmpty(`teamSelect_%${currentCount}%#${currentId}`))}
                      requiredMessage={this.display('select') ? '' : t('teamName-required')}
                      hasFeedback
                      maxlength={75}
                      counter={true}
                      onChange={value => this.handleBubbleFields('text', value, currentCount, currentId, canJoinTeam ? `teamSelect_%${currentCount}%#${currentId}` : undefined)}
                    /> || null
                  }
                  {canJoinTeam &&
                    <SelectField
                      form={form}
                      fieldId={`teamSelect_%${_count}%#${id}`}
                      placeholder={t('select-team')}
                      className="teamSelect"
                      optionsArray={this.getTeamsList()}
                      dropdownClassName="TicketsDetailsForm__AboutRegistration__Dropdown"
                      colon={false}
                      onChange={value => this.handleBubbleFields('select', value, currentCount, currentId, canCreateTeam ? `teamName_%${currentCount}%#${currentId}` : undefined)}
                      required={(required && this.otherFieldEmpty(`teamName_%${currentCount}%#${currentId}`))}
                      requiredMessage={t('teamSelect-required' + (this.display('textField') ? '-orName' : ''))}
                      initialValue={get(purchaseInformation, 'participation.team.teamId', undefined)}
                    /> || null
                  }
                </div>
                {get(event, 'settings.attendee.information.request', null) == 1 &&
                  <div className="TicketsDetailsForm__Ticket--row">
                    <TextField
                      form={form}
                      fieldId={`firstName_%${_count}%#${id}`}
                      placeholder={t('first-name')}
                      required={required}
                      requiredMessage={t('firstName-required')}
                      initialValue={purchaseInformation && this.getInitialTicketInformation('firstName', id, _count, get(purchaseInformation, 'tickets')) || undefined}
                      hasFeedback
                      maxlength={75}
                      counter={true}
                      fieldOptions={{
                        rules: [...nameFieldValidator(true, 75, true, 'firstname')]
                      }}
                    />
                    <TextField
                      form={form}
                      fieldId={`lastName_%${_count}%#${id}`}
                      placeholder={t('last-name')}
                      required={required}
                      requiredMessage={t('lastName-required')}
                      initialValue={purchaseInformation && this.getInitialTicketInformation('lastName', id, _count, get(purchaseInformation, 'tickets')) || undefined}
                      hasFeedback
                      maxlength={75}
                      counter={true}
                      fieldOptions={{
                        rules: [...nameFieldValidator(true, 75, true, 'lastname')]
                      }}
                    />
                  </div>
                }
                {(get(event, 'settings.attendee.information.email', null) == 1 ||
                  get(event, 'settings.attendee.information.username', null) == 1) &&
                <div className="TicketsDetailsForm__Ticket--row">
                  {get(event, 'settings.attendee.information.username', null) == 1 &&
                  <TextField
                    form={form}
                    fieldId={`username_%${_count}%#${id}`}
                    placeholder={t('user-name')}
                    required={required}
                    requiredMessage={t('username-required')}
                    initialValue={purchaseInformation && this.getInitialTicketInformation('username', id, _count, get(purchaseInformation, 'tickets')) || undefined}
                    hasFeedback
                    maxlength={75}
                    counter={true}
                    fieldOptions={{
                      rules: [...usernameFieldValidator(true, 75, true)]
                    }}
                  />
                  }
                  {get(event, 'settings.attendee.information.email', null) == 1 &&
                  <EmailField
                    className=""
                    form={form}
                    fieldId={`email_%${_count}%#${id}`}
                    label={false}
                    placeholder={true}
                    required={required}
                    requiredMessage={t('email-required')}
                    initialValue={purchaseInformation && this.getInitialTicketInformation('email', id, _count, get(purchaseInformation, 'tickets')) || undefined}
                  />
                  }
                </div>
                }
              </div>
            );

            count++;
            _count++;
          }
        }
      }
    }

    return fields;
  };

  getInitialTicketInformation = (field, id, count, tickets) => {
    return tickets &&
      tickets
        .filter(ticket => ticket.ticketId === id)
        .map(ticket => {
          return get(ticket, `attendees[${count - 1}].${field}`, undefined)
        })[0] ||
      undefined;
  };

  getTeamsList = () => {
    const { teams, campaign } = this.props;
    const participantLimit = get(campaign, 'settings.participant.limit', 0);
    
    return teams
      .filter(team => {
        const participantCount = get(team, 'childrenCount.participants', 0)

        return parseInt(participantLimit) === 0 || parseInt(participantLimit) - parseInt(participantCount) > 0;
      })
      .map(team => ({value: team.id, text: team.name}));
  };

  getAttendees = (id, quantity, typeId) => {
    const formValues = this.props.form.getFieldsValue();
    const attendees = [];
    const { user, event } = this.props;

    let i, field, fieldName, count, attendee;

    let isAttendeesInfoRequested = get(event, 'settings.attendee.information.request') == 1;

    for (i = 1; i <= quantity; i++) {
      if (!isAttendeesInfoRequested) {
        attendee = {
          firstName: user.firstName,
          lastName: user.lastName,
        };
      } else {
        attendee = {};
      }
      
      for (field in formValues) {
        if (field.search(new RegExp('#' + id + '$')) > -1) {
          count = field.split('%')[1];
          if (i == count) {
            fieldName = field.split('_')[0];
            if(fieldName === 'teamName') {
              if(!attendee.team) attendee.team = {}
              attendee.team.name = formValues[field]
            }
            else if(fieldName === 'teamSelect') {
              if(!attendee.team) attendee.team = {}
              attendee.team.teamId = formValues[field]
            }
            else
              attendee[fieldName] = formValues[field]
          }
        }
      }

      if(!attendee.team)
        attendee.self = true;

      attendees.push(attendee);
    }

    return attendees;
  };

  display = element => {
    const { teams, campaign, form, ticketSelection } = this.props;
    const campaignTypeId = get(campaign, 'typeId', 0);
    const selectedPackageId = form.getFieldValue('packageSelect');
    const selectedPackageTypeId = ticketSelection.tickets
      .filter(row => row.ticket.id === selectedPackageId)
      .map(row => row.ticket.typeId)[0] || null;
    const teamsLength = parseInt(get(teams, 'length', 0));
    const teamsLimit = parseInt(get(campaign, 'settings.team.limit', 0));
    const participantsLimit = parseInt(get(campaign, 'settings.participant.limit', 0));
    const participantLength = parseInt(get(campaign, 'childrenCount.participant', 0));
    const displaySelectTeam = this.getTeamsList().length && selectedPackageTypeId !== 2;
    const displayTextField = teamsLimit === 0 || teamsLimit && teamsLength < teamsLimit;

    switch (element) {
      case 'selectTeam':
        return displaySelectTeam;
      case 'or':
        return displaySelectTeam && displayTextField;
      case 'textField':
        return displayTextField;
      case 'bubble':
        return displaySelectTeam || displayTextField;
      case 'questions':
        return campaignTypeId !== 4 && participantsLimit === 0 ||
          campaignTypeId === 1 && participantsLimit && participantLength < participantsLimit ||
          campaignTypeId === 2 && (displaySelectTeam || displayTextField) ||
          campaignTypeId === 3 && (selectedPackageTypeId !== 2 || selectedPackageTypeId === 2 && displayTextField);
      default:
        return false;
    }
  };

  isProfileCompleted = () => {
    const classes = document.querySelector('.UserCard').className.split(' ') || [];

    return classes.indexOf('completed') > -1;
  };

  handleChangePurchaseType = (e) => {
    if (get(e, 'target.value', 0) > 0) {
      this.setState({
        openInfoCard: true,
        isCorporate: get(e, 'target.value', 0) === 2
      });
    } else {
      this.setState({
        openInfoCard: false,
        isCorporate: false
      });
    }
  };

  otherFieldEmpty = (id) => {
    let field = document.getElementById(id);
    
    if(!field || (!field.value && field.innerText.length === 0))
      return true
    return false
  }

  render() {
    const {
        props, state, handleSubmit, getTicketsInfoFields, getTeamsList, display, handleBubbleFields,
        handleSelectPackage, handleCheckForOtherPeople, handleRadioQuestionPage, handleRadioQuestionTeam
      } = this,
      { t, form, locale, ticketSelection, purchaseInformation, campaign, event } = props,
      { disableSelectPackage, packageSelectRequired, teamRequired,
        openQuestionPage, openQuestionTeam, openBubbleTeam,
        openSectionTicket, openSectionQuestion,
        openInfoCard, isCorporate
      } = state,
      { getFieldDecorator } = form;

    const connected = this.props.userTypeId === 2;

    // const packageSelectOptions = ticketSelection && ticketSelection.tickets
    //   ? ticketSelection.tickets.map(ticket => ({
    //       value: get(ticket, 'ticket.id', 0),
    //       text: get(ticket, 'ticket.description.name', `#${get(ticket, 'ticket.id', 0)}`)
    //     }))
    //   : [];

    return (
      <div className="FundkyWrap">
        <Form className="TicketsDetailsForm" onSubmit={handleSubmit}>
          {/* <Countdown
            duration={7 * 60 * 1000}
            display={{
              // days: true,
              // hours: true,
              minutes: true,
              seconds: true,
              // milliseconds: true
            }}
            onFinish={()=>{}}
          /> */}
          <section className="TicketsDetailsForm__BuyerInfo">
            <h2>{t('buyer-information')}</h2>
            <BuyerTypeField
              className="CreateDonationForm__Field"
              form={this.props.form}
              initialValue={get(purchaseInformation, 'donationTypeId')}
              label={false}
              placholder={false}
              onChange={this.handleChangePurchaseType}
            />
            <Collapse isOpened={openInfoCard}>
              <UserInformationCards isCorporate={isCorporate} />
            </Collapse>
          </section>
          {(get(campaign, 'typeId') !== CAMPAIGN_TEMPLATE_SOLO && !this.isLeader) &&
          <Collapse isOpened={openSectionQuestion} hasNestedCollapse>
            <section className="TicketsDetailsForm__AboutRegistration">
              <h2>{t('about-registration')}</h2>
              {/* <div className="TicketsDetailsForm__AboutRegistration--select">
                <SelectField
                  form={form}
                  fieldId="packageSelect"
                  placeholder={t('select-package-placeholder')}
                  className="packageSelect"
                  optionsArray={packageSelectOptions}
                  onChange={handleSelectPackage}
                  dropdownClassName="TicketsDetailsForm__AboutRegistration__Dropdown"
                  disabled={disableSelectPackage}
                  required={packageSelectRequired}
                  requiredMessage={t('select-package-required')}
                  initialValue={purchaseInformation && get(purchaseInformation, 'selectedPackage') || undefined}
                />
                <CheckboxField
                  fieldId="for_others"
                  form={form}
                  checkboxText={t('check-for-others')}
                  onChange={handleCheckForOtherPeople}
                  rules={[{
                    validator: (rule, value, callback) => value || !packageSelectRequired
                      ? callback()
                      : callback(true),
                    message: t('check-for-others-required')
                  }]}
                  initialValue={
                    purchaseInformation &&
                    !get(purchaseInformation, 'participation.team.teamId', undefined) &&
                    !get(purchaseInformation, 'participation.team.name', undefined) &&
                    !get(purchaseInformation, 'participation.self', undefined)
                      ? true
                      : undefined
                  }
                />
              </div> */}

              {/* <Collapse isOpened={openQuestionPage}>
                <h3>{t('question-page')}</h3>
                <p>{t('question-page-desc')}</p>
                <Form.Item
                  className="radioQuestionPage"
                  hasFeedback
                >
                  {getFieldDecorator(
                    'radioQuestionPage',
                    {
                      rules: [
                        {
                          required: openQuestionPage,
                          message: t('question-required')
                        }
                      ],
                      onChange: handleRadioQuestionPage,
                      initialValue:
                        get(purchaseInformation, 'participation.team.teamId', undefined) ||
                        get(purchaseInformation, 'participation.team.name', undefined) ||
                        get(purchaseInformation, 'participation.self', undefined)
                          ? 1
                          : purchaseInformation
                            ? 0
                            : undefined
                    }
                  )(
                    <Radio.Group>
                      <Radio value={1}>{t('yes')}</Radio>
                      <Radio value={0}>{t('no')}</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Collapse> */}

              <Collapse isOpened={openQuestionTeam}>
                <h3>{t('question-team')}</h3>
                <p>{t('question-team-desc')}</p>
                <Form.Item
                  className="radioQuestionTeam"
                  hasFeedback
                >
                  {getFieldDecorator(
                    'radioQuestionTeam',
                    {
                      rules: [
                        {
                          required: openQuestionTeam,
                          message: t('question-required')
                        }
                      ],
                      onChange: handleRadioQuestionTeam,
                      initialValue:
                        get(purchaseInformation, 'participation.team.teamId', undefined) ||
                        get(purchaseInformation, 'participation.team.name', undefined)
                          ? 1
                          : get(purchaseInformation, 'participation.self', undefined)
                            ? 0
                            : undefined
                    }
                  )(
                    <Radio.Group>
                      <Radio value={1}>{t('team')}</Radio>
                      <Radio value={0}>{t('myself')}</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Collapse>

              {/* <Collapse isOpened={openBubbleTeam}>
                <div className="TicketsDetailsForm--bubble">
                  {display('selectTeam') &&
                    <SelectField
                      form={form}
                      label={t('select-team')}
                      fieldId="teamSelect"
                      //placeholder={t('select-team-placeholder')}
                      className="teamSelect"
                      optionsArray={getTeamsList()}
                      dropdownClassName="TicketsDetailsForm__AboutRegistration__Dropdown"
                      colon={false}
                      onChange={value => handleBubbleFields('select', value)}
                      required={(teamRequired || !display('textField')) && openBubbleTeam}
                      requiredMessage={t('teamSelect-required' + (display('textField') ? '-alt' : ''))}
                      initialValue={get(purchaseInformation, 'participation.team.teamId', undefined)}
                    />
                  }
                  {display('or') &&
                    <span>{t('or')}</span> || null
                  }
                  {display('textField') &&
                    <TextField
                      form={form}
                      label={t('create-team')}
                      fieldId="teamName"
                      placeholder={t('team-name-placeholder')}
                      colon={false}
                      onChange={value => handleBubbleFields('text', value)}
                      required={(teamRequired || !display('selectTeam')) && openBubbleTeam}
                      requiredMessage={t('teamName-required' + (display('selectTeam') ? '-alt' : ''))}
                      initialValue={get(purchaseInformation, 'participation.team.name', undefined)}
                    /> || null
                  }
                </div>
              </Collapse> */}
            </section>
          </Collapse>
          || null
          }
          {(get(event, 'settings.attendee.information.request', null) == 1 || this.hasTeamRelatedFields) &&
          <Collapse isOpened={openSectionTicket}>
            <section className="TicketsDetailsForm__TicketInformation">
              <h2>{t('ticket-information')}</h2>
              <div className="TicketsDetailsForm__TicketInformation--list">
                {getTicketsInfoFields()}
              </div>
            </section>
          </Collapse>
          }
          <div className="TicketsDetailsForm__CTA">
            <p>{t('accept-text')}</p>
            <FundkyButton
              // className=""
              type="primary"
              size="large"
              text={t('next')}
              // action={{ func:  }}
              disabled={!connected
                ? true
                : this.campaignTypeId === CAMPAIGN_TEMPLATE_PARTICIPANTS || this.campaignTypeId === CAMPAIGN_TEMPLATE_SOLO
                  ? false
                  : !openSectionQuestion
              }
              onClick={handleSubmit}
            />
            {/* <FundkyButton
              // className=""
              type="text-primary"
              size="small"
              text={t('cancel')}
              // action={{ func:  }}
              // disabled={}
            /> */}
          </div>
          <div className="TicketsDetailsForm__CancelWrapper">
              <Popconfirm placement="topLeft" getPopupContainer={() => document.getElementById('popContainer3')} title={t('TRANSACTION:cancelText')} onConfirm={this.handleCancelClick} okText={t('TRANSACTION:yes')} cancelText={t('TRANSACTION:no')}>
                <span id="popContainer3">
                  {t('cancel')}
                </span>
              </Popconfirm>
            </div>
        </Form>
      </div>
    );
  }
}

TicketsDetailsForm.propTypes = {
  form: PropTypes.object.isRequired
};

export default translate('TicketsDetailsForm')(TicketsDetailsForm);
